import type { Event } from 'effector';

import { createDomain, sample } from 'effector';

import type { FormConfig } from 'effector-forms';

import { createForm } from 'effector-forms';

import { typedObjectEntries } from '@shared/lib/prototype';

type EnrichedFormConfig<T> = FormConfig<T> & {
  resetOn?: Event<void>;

  blurValidatePreset?: boolean;
};

const createPatchedForm = <T>({
  resetOn,
  blurValidatePreset,
  ...config
}: EnrichedFormConfig<T>) => {
  const touched = createDomain();

  typedObjectEntries(config.fields).forEach(([_, field]) => {
    if (!field.units) {
      field.units = {};
    }

    field.units.$isTouched = touched.createStore(false);

    if (blurValidatePreset) {
      field.validateOn = ['blur'];
    }
  });

  if (blurValidatePreset) {
    config.validateOn = ['submit'];
  }

  const form = createForm(config);

  touched.onCreateStore(store => store.on(form.submit, () => true));

  if (resetOn) {
    sample({
      clock: resetOn,
      target: form.reset
    });
  }

  return form;
};

export { createPatchedForm };
